<template>
  <div>
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/creation/chuangzuo_title1.png'"
        alt="少儿编程"
        style="width: 256px;height: 50px;margin-top: 100px;"
      ></el-image>
    </div>
    <div class="center">
      <div class="between" style="width: 1200px;margin-top: 60px;">
        <el-image
          :src="$domain + 'static/noten/website/creation/chuangzuo_card1.png'"
          alt="编程"
          style="width: 356px;height: 194px;border-radius: 20px;cursor: pointer;"
          @click="openLink"
        ></el-image>
        <el-image
          :src="$domain + 'static/noten/website/creation/chuangzuo_card2.png'"
          alt="编程"
          style="width: 356px;height: 194px;border-radius: 20px;"
          @click="toC"
        ></el-image>
        <el-image
          :src="$domain + 'static/noten/website/creation/chuangzuo_card3.png'"
          alt="编程"
          style="width: 356px;height: 194px;border-radius: 20px;"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openLink() {
      window.open(
        "https://static.smallschoolbag.com/static/ciyuankoudai/noten/programming/build/index.html"
      ); // 替换为你要打开的链接
    },
    toC() {
      this.$router.push({ name: "EditC++" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/creation/components/idea.vue